import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { AcademicYear } from '../../../../../models/academic-year';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { SettingsService } from '../../../../../services/settings/settings.service';
import { AcademicYearService } from '../../../../../services/user/academic-year/academic-year.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { BusRoute, BusStop, BusPassRequest } from '../../../apply/models/bus-pass-info';
import { StudentProfileInfo } from '../../../profile/models/student-profile-info';
import { StudentProfileService } from '../../../profile/services/student-profile.service';
import { BusPassApplicationService } from '../../services/bus-pass-application.service';
import { RateService } from 'rate';

@Component({
  selector: 'app-bus-pass-application',
  templateUrl: './bus-pass-application.component.html',
  styleUrls: ['./bus-pass-application.component.scss']
})
export class BusPassApplicationComponent extends ComponentBase implements OnInit {

  constructor(private pageHeadingService: PageHeadingService
    , private busPassApplicationService: BusPassApplicationService
    , private studentProfileService: StudentProfileService
    , private settingsService: SettingsService
    , private rateService: RateService
    , private academicYearService: AcademicYearService) {
    super();
  }

  studentProfileInfo: StudentProfileInfo;

  canApply: boolean = false;
  isPending: boolean = false;
  isApproved: boolean = false;
  isDropPonitEnabled: boolean = false;

  academicYear: AcademicYear;

  selectedPickUpPoint: BusStop;
  selectedDropPoint: BusStop;

  applyClicked: boolean = false;

  hasError: boolean = false;
  routes: BusRoute[] = [];

  error: string;

  public busPassRequest: BusPassRequest;

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Bus pass"));

    let sub1 = this.settingsService.getSettings()
      .subscribe(res => {
        this.isDropPonitEnabled = res.is_drop_ponit_enabled;
      });
    this.addSubscription(sub1)

    let sub2 = this.busPassApplicationService.getBusPassStatus()
      .subscribe(res => {
        this.bindBusPassStatus(res);
      });
    this.addSubscription(sub2);

    let sub3 = this.studentProfileService.getProfileInfo()
      .subscribe(res => {
        this.studentProfileInfo = res;
      });
    this.addSubscription(sub3);

    let sub4 = this.academicYearService.getAcademicYear()
      .subscribe(res => {
        this.academicYear = res;
      });
    this.addSubscription(sub4);

    let busRoutesSubscription = this.busPassApplicationService.getAllBusRoutes()
      .subscribe((res) => {
        this.routes = res;
      });
    this.addSubscription(busRoutesSubscription);
  }

  bindBusPassStatus(busPassRequest: BusPassRequest) {
    this.canApply = false;
    this.busPassRequest = busPassRequest;
    this.isPending = false;
    this.isApproved = false;
    if (busPassRequest) {
      if (busPassRequest.status == 0) {
        this.isPending = true;
      }
      else if (busPassRequest.status == 2) {
        this.isApproved = true;
      } else {
        if (busPassRequest.comments) {
          if (busPassRequest.status == 4) {
            this.error = "Rejected: " + busPassRequest.comments;
          } else {
            this.error = busPassRequest.comments;
          }
        }
        this.canApply = true;
      }
    }
    else {
      this.canApply = true;
    }
  }

  applyClick() {
    this.error = null;
    this.applyClicked = true;
    if (this.isDropPonitEnabled) {
      if (!this.selectedPickUpPoint || !this.selectedDropPoint) {
        this.hasError = true;
        return;
      }
    }
    else {
      if (!this.selectedPickUpPoint) {
        this.hasError = true;
        return;
      }
    }
    let sub = this.busPassApplicationService.apply(this.selectedPickUpPoint.bus_stop_route_mapping_id,
      this.selectedDropPoint ? this.selectedDropPoint.bus_stop_route_mapping_id : null)
      .subscribe((res) => {
        this.bindBusPassStatus(res);
        this.rateService.showRate();
      }, (err) => {
        this.error = err['message'];
      });
    this.addSubscription(sub);
  }
}
